<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card class="mb-4">
                    <v-card-title>
                        <span class="title">Chiến dịch gửi tin</span>
                        <v-spacer></v-spacer>
                        <v-btn icon title="Làm mới danh sách chiến dịch" @click="loadCampaigns">
                            <v-icon>fa-sync</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-data-table
                        :headers="campaignHeaders"
                        :items="campaigns"
                        :loading="loading"
                        :items-per-page="10"
                    >
                        <template v-slot:item.Status="{ item }">
                            <span :style="{ color: get_type_color(item.Status, campaignStatus) }">
                                {{ item.Status | display_value(campaignStatus) }}
                            </span>
                        </template>
                        <template v-slot:item.Progress="{ item }">
                            {{ item.SentCount || 0 }}/{{ item.TotalMessages || 0 }} đã gửi
                            <span v-if="item.PendingCount"> · còn {{ item.PendingCount }}</span>
                            <span v-if="item.ErrorCount"> · {{ item.ErrorCount }} lỗi</span>
                            <span v-if="item.CancelledCount"> · {{ item.CancelledCount }} đã hủy</span>
                        </template>
                        <template v-slot:item.SendTime="{ item }">
                            {{ formatTime(item.SendStartTime) }}–{{ formatTime(item.SendEndTime) }}
                            · {{ item.SendIntervalSeconds }} giây/tin
                        </template>
                        <template v-slot:item.CreatedDate="{ item }">
                            {{ item.CreatedDate | display_date }}
                        </template>
                        <template v-slot:item.Actions="{ item }">
                            <v-btn icon small title="Xem danh sách tin" @click="viewCampaignMessages(item)">
                                <v-icon small>fa-eye</v-icon>
                            </v-btn>
                            <v-btn v-if="roleAdmin && item.Status === 1" icon small color="orange darken-2" title="Tạm dừng" @click="changeCampaignStatus(item, 2)">
                                <v-icon small>fa-pause</v-icon>
                            </v-btn>
                            <v-btn v-if="roleAdmin && item.Status === 2" icon small color="green darken-2" title="Tiếp tục gửi" @click="changeCampaignStatus(item, 1)">
                                <v-icon small>fa-play</v-icon>
                            </v-btn>
                            <v-btn v-if="roleAdmin && (item.Status === 1 || item.Status === 2)" icon small color="red darken-2" title="Hủy chiến dịch" @click="changeCampaignStatus(item, 3)">
                                <v-icon small>fa-times-circle</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
            <v-flex lg12>
                <v-card>
                    <v-alert v-if="selectedCampaign" dense text type="info" class="ma-3">
                        Đang xem tin của chiến dịch: <strong>{{ selectedCampaign.CampaignName }}</strong>
                        <v-btn text small color="primary" @click="clearCampaignFilter">Xem tất cả</v-btn>
                    </v-alert>
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>{{ getCampaignName(item.CampaignID) }}</td>
                                <td>{{ item.TemplateID }}</td>
                                <td>{{ item.TemplateName }}</td>
                                <td>{{ item.Username }}</td>
                                <td>{{ item.PhoneNumber }}</td>
                                <td v-bind:style="{ 'color': get_type_color(item.Status, zns_status)}">{{ item.Status | display_value(zns_status) }}</td>
                                <td>{{ item.CreatedDate | display_date }}</td>
                                <td>{{ item.Exception }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
            <v-dialog v-model="dialogZns" persistent max-width="700px">
                <v-card>
                    <v-form ref="entryForm">
                        <v-card-title>
                            <span class="title">Gửi thông báo ZNS</span>
                        </v-card-title>
                        <v-card-text>
                            <v-layout row wrap pa-3>
                                <v-text-field
                                    v-model="campaignName"
                                    label="Tên chiến dịch"
                                    :rules="requireRules"
                                    counter="200"
                                    maxlength="200"
                                ></v-text-field>
                                <v-select :items="templates" v-model="selectedTemplate" label="Mẫu ZNS" item-text="templateName" item-value="templateId" return-object clearable></v-select>
                                <v-expansion-panels v-model="panel" mandatory>
                                    <v-expansion-panel key="select_customer">
                                        <v-expansion-panel-header>
                                            Theo liên hệ
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-autocomplete :multiple="true" label="Liên hệ" v-model="selectedContacts" :items="contacts" :item-text="getContactText" item-value="ID" clearable></v-autocomplete>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel key="select_province">
                                        <v-expansion-panel-header>
                                            Theo tỉnh thành
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-autocomplete :multiple="true" label="Tỉnh/thành phố" :items="provinces" v-model="selectedProvinces" item-text="name" item-value="id" clearable></v-autocomplete>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel key="select_kind">
                                        <v-expansion-panel-header>
                                            Theo quy mô
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-select :multiple="true" :items="contact_kinds" v-model="selectedKinds" label="Quy mô" item-text="name" item-value="value" clearable></v-select>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel key="upload_excel">
                                        <v-expansion-panel-header>
                                            Danh sách excel
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-flex lg12 md12 sm12 xs12>
                                                <v-layout row wrap>
                                                    <v-flex lg12 md12 sm12 xs12>
                                                        <v-icon medium class="ma-2" color="gray darken-3" @click="insertRow">fa-plus-square</v-icon>
                                                        <v-icon medium class="ma-2" color="gray darken-3" @click="deleteRow">fa-trash-alt</v-icon>
                                                        <v-icon medium class="ma-2" color="gray darken-3" @click="importRow">fa-upload</v-icon>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap>
                                                    <v-flex lg12 md12 sm12 xs12>
                                                        <vue-excel-editor ref="excel_editor" v-model="contactData" :no-paging="true" :new-if-bottom="true">
                                                            <template v-for="(item, index) in contactColumns">
                                                                <vue-excel-column v-if="item && item !== undefined" :field="item.name" :width="item.width ? item.width : '100px'" :label="item.label" :key-field="item.key_field" :type="item.type ? item.type : 'string'" :options="item.options" :key="index"/>
                                                            </template>
                                                        </vue-excel-editor>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                                <v-flex lg12 md12 sm12 xs12 mt-4>
                                    <v-textarea
                                        v-model="additionalPayload"
                                        label="Tham số bổ sung cho Payload (JSON)"
                                        hint='Ví dụ: {"exp_date": "30/08/2026"}'
                                        persistent-hint
                                        outlined
                                        rows="4"
                                    ></v-textarea>
                                </v-flex>
                                <v-flex lg4 md4 sm12 xs12>
                                    <v-text-field
                                        v-model.number="sendIntervalSeconds"
                                        type="number"
                                        min="1"
                                        max="3600"
                                        label="Khoảng cách gửi (giây)"
                                        :rules="sendIntervalRules"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex lg4 md4 sm12 xs12>
                                    <v-text-field
                                        v-model="sendStartTime"
                                        type="time"
                                        label="Bắt đầu gửi"
                                        :rules="requireRules"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex lg4 md4 sm12 xs12>
                                    <v-text-field
                                        v-model="sendEndTime"
                                        type="time"
                                        label="Kết thúc gửi"
                                        :rules="requireRules"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click="dialogZns = false">Đóng</v-btn>
                            <v-btn color="blue darken-1" text @click="sendZns">Hoàn thành</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-container>
    </template>
    
    <script>
    import { mapState } from "vuex";
    import configs from "@/configs";
    import Filtering from "@/components/Filtering";
    import { sendErrorNotice } from "@/commons/utils";
    import _ from "lodash";
    
    export default {
        components: {
            "hpo-filter": Filtering
        },
        data() {
            return {
                headers: [{
                        text: "Chiến dịch",
                        value: "CampaignID",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "TemplateID",
                        value: "TemplateID",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Tên mẫu",
                        value: "TemplateName",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "User name",
                        value: "Username",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Số điện thoại",
                        value: "PhoneNumber",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Trạng thái",
                        value: "Status",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Enum"],
                        values: configs.ZNS_STATUS
                    },
                    {
                        text: "Ngày tạo",
                        value: "CreatedDate",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Date"]
                    },
                    {
                        text: "Lỗi",
                        value: "Exception",
                        filterable: true,
                        dataType: configs.DATA_TYPE["String"]
                    }
                ],
                campaignHeaders: [
                    { text: "Tên chiến dịch", value: "CampaignName" },
                    { text: "Mẫu ZNS", value: "TemplateName" },
                    { text: "Trạng thái", value: "Status" },
                    { text: "Tiến độ", value: "Progress", sortable: false },
                    { text: "Lịch gửi", value: "SendTime", sortable: false },
                    { text: "Người tạo", value: "CreatedByName" },
                    { text: "Ngày tạo", value: "CreatedDate" },
                    { text: "Thao tác", value: "Actions", sortable: false, align: "center" }
                ],
                requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
                sendIntervalRules: [
                    v => Number.isInteger(Number(v)) || "Khoảng cách gửi phải là số nguyên.",
                    v => Number(v) >= 1 && Number(v) <= 3600 || "Khoảng cách gửi từ 1 đến 3600 giây."
                ],
                zns_status: configs.ZNS_STATUS,
                campaignStatus: configs.ZNS_CAMPAIGN_STATUS,
                pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
                items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
                viewName: "zns_list",
                filterConditions: [],
                quickFilterConditions: [],
                dialogZns: false,
                panel: 0,
                selectedContacts: null,
                selectedProvinces: null,
                selectedKinds: null,
                selectedTemplate: null,
                campaignName: "",
                selectedCampaign: null,
                additionalPayload: "{}",
                sendIntervalSeconds: 1,
                sendStartTime: "00:00",
                sendEndTime: "23:59",
                contactData: [],
                contactColumns: [
                    {
                        'name': 'user_name',
                        'width': '300px',
                        'label': 'Tên liên hệ',
                        'key_field': false,
                        'type': 'string'
                    },
                    {
                        'name': 'phone',
                        'width': '280px',
                        'label': 'Số điện thoại',
                        'key_field': false,
                        'type': 'string'
                    }
                ]
            };
        },
        watch: {
            pagination: {
                handler: function (val, oldVal) {
                    let filterConditions = this.$store.state.commons.filterConditions;
                    this.filterConditions = !_.isEmpty(filterConditions) ?
                        filterConditions[this.viewName] : [];
                    this.filter_data();
                },
                deep: true
            },
            roleAdmin() {
                this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !this.roleAdmin});
            }
        },
        computed: {
            ...mapState({
                items: state => state.znsMsg.all.data,
                total_rows: state => state.znsMsg.all.total,
                loading: state => state.znsMsg.loading,
                configuration: state => state.configuration.selected,
                contacts: state => state.contact.all.data,
                provinces: state => state.commons.provinces,
                templates: state => state.znsMsg.templates,
                campaigns: state => state.znsMsg.campaigns,
            }),
            contact_kinds() {
                return this.configuration && this.configuration.ContactKind ? JSON.parse(this.configuration.ContactKind) : [];
            },
            roleAdmin() {
                return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
            },
            rolePayment() {
                return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
            },
            roleCS() {
                return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
            }
        },
        methods: {
            filter_data: function () {
                var param = {
                    pagination: this.pagination,
                    filter: this.filterConditions,
                    quickFilter: this.quickFilterConditions
                };
                this.$store.dispatch("znsMsg/getList", param);
            },
            sendZns() {
                if (!this.selectedTemplate) {
                    sendErrorNotice("Hãy chọn mẫu tin ZNS!");
                    return;
                }
                if (this.panel === undefined) {
                    sendErrorNotice("Hãy chọn kiểu gửi tin!");
                    return;
                }
                if (!this.$refs.entryForm.validate()) {
                    return;
                }
                let additionalPayload = null;
                try {
                    additionalPayload = JSON.parse(this.additionalPayload || "{}");
                }
                catch (e) {
                    sendErrorNotice("Tham số bổ sung phải là JSON hợp lệ.");
                    return;
                }
                if (!additionalPayload || Array.isArray(additionalPayload) || typeof additionalPayload !== "object") {
                    sendErrorNotice("Tham số bổ sung phải là một JSON object.");
                    return;
                }
                let payload = {
                    'panel': this.panel,
                    'template_id': this.selectedTemplate.templateId,
                    'template_name': this.selectedTemplate.templateName,
                    'campaign_name': this.campaignName,
                    'additional_payload': additionalPayload,
                    'send_interval_seconds': Number(this.sendIntervalSeconds),
                    'send_start_time': this.sendStartTime,
                    'send_end_time': this.sendEndTime
                };
                if (this.panel == 0) {
                    payload.contacts = this.selectedContacts;
                }
                else if (this.panel == 1) {
                    payload.provinces = this.selectedProvinces;
                }
                else if (this.panel == 2) {
                    payload.kinds = this.selectedKinds;
                }
                else {
                    payload.excel = this.contactData;
                }
                this.$store.dispatch("znsMsg/send_zns", payload).then(() => {
                    this.dialogZns = false;
                    this.campaignName = "";
                    this.loadCampaigns();
                    this.filter_data();
                });
            },
            loadCampaigns() {
                this.$store.dispatch("znsMsg/get_campaigns");
            },
            changeCampaignStatus(campaign, status) {
                let actionName = status === 1 ? "tiếp tục" : (status === 2 ? "tạm dừng" : "hủy");
                if (!confirm(`Bạn có chắc chắn muốn ${actionName} chiến dịch "${campaign.CampaignName}"?`)) {
                    return;
                }
                this.$store.dispatch("znsMsg/update_campaign_status", { id: campaign.ID, status }).then(() => {
                    this.loadCampaigns();
                    this.filter_data();
                });
            },
            viewCampaignMessages(campaign) {
                this.selectedCampaign = campaign;
                this.filterConditions = _.filter(this.filterConditions, condition => condition.column !== "CampaignID");
                this.filterConditions.push({
                    column: "CampaignID",
                    condition: "equal",
                    value: campaign.ID
                });
                this.saveMessageFilters();
                this.filter_data();
            },
            clearCampaignFilter() {
                this.selectedCampaign = null;
                this.filterConditions = _.filter(this.filterConditions, condition => condition.column !== "CampaignID");
                this.saveMessageFilters();
                this.filter_data();
            },
            saveMessageFilters() {
                let allFilterConditions = this.$store.state.commons.filterConditions || {};
                allFilterConditions[this.viewName] = this.filterConditions;
                this.$store.commit("commons/setFilterConditions", { filter: allFilterConditions });
            },
            getCampaignName(campaignId) {
                if (!campaignId) {
                    return "Không thuộc chiến dịch";
                }
                let campaign = _.find(this.campaigns, { ID: campaignId });
                return campaign ? campaign.CampaignName : `#${campaignId}`;
            },
            formatTime(value) {
                return value ? String(value).substring(0, 5) : "--:--";
            },
            applyFilter(filterConditions) {
                let sortBy = this.pagination.sortBy;
                let sortDesc = this.pagination.sortDesc;
                this.pagination = configs.PAGINATION;
                this.pagination.sortBy = sortBy;
                this.pagination.sortDesc = sortDesc;
                this.filterConditions = filterConditions || [];
                if (this.selectedCampaign && !_.find(this.filterConditions, { column: "CampaignID" })) {
                    this.filterConditions.push({
                        column: "CampaignID",
                        condition: "equal",
                        value: this.selectedCampaign.ID
                    });
                }
                this.saveMessageFilters();
                this.filter_data();
            },
            quickFilter(filterConditions) {
                this.quickFilterConditions = filterConditions;
                this.filter_data();
            },
            createData() {
                this.dialogZns = true;
            },
            get_type_color(val, enums) {
                return this.$options.filters.display_color(val, enums);
            },
            getContactText(item) {
                return `${item.PhoneNumber} - ${item.FullName}`
            },
            deleteRow() {
                this.$refs.excel_editor.deleteSelectedRecords()
            },
            insertRow() {
                this.$refs.excel_editor.newRecord()
            },
            importRow() {
                this.$refs.excel_editor.importTable();
            },
        },
        mounted() {
            this.$store.dispatch("commons/getProvinces", {});
            this.$store.dispatch("contact/getList");
            this.$store.dispatch("znsMsg/get_zns_template");
            this.loadCampaigns();
            this.$store.dispatch("configuration/getDetail", 1);
            this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !this.roleAdmin});
            this.$root.$on("REQUEST_CREATE_DATA", this.createData);
            this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        },
        beforeDestroy() {
            this.$root.$off("REQUEST_CREATE_DATA");
            this.$root.$off("REQUEST_REFRESH_DATA");
        }
    };
    </script>
